var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHighScore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.05 19.8H0V6.6h6.05zM14.025 0h-6.05v19.8h6.05zM22 8.8h-6.05v11H22z"
})));
export { SvgHighScore as ReactComponent };
export default __webpack_public_path__ + "c3be920a5af62bbc6ed7617f98f58e48.svg";